// import {combineReducer} from "redux";
import affiliates from './affiliatesReducer';

// if there are more than one reducer in this component, use combineReducer
/*
const affiliates = combineReducer({
    affiliates
})
*/
export default affiliates;
